import "ngstorage";

class PosttypesController {
  constructor(
    $http,
    $localStorage,
    $state,
    $stateParams,
    AuthService,
    SecurityService,
    SignupValidator,
    CompaniesService,
    $timeout,
    $rootScope,
    EnvService,
    ngProgressFactory,
    $scope,
    $location
  ) {
    this.name = "posttypes";
    $localStorage.activeStateName = "posttypes";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$timeout = $timeout;
    this.$scope = $scope;
    this.$auth = AuthService;
    this.$companies = CompaniesService;
    this.$security = SecurityService;
    this.$progress = ngProgressFactory.createInstance();
    this.disableDNH = true;
    this.$rootScope = $rootScope;
    this.dnhJobblers = [];
    this.validator = SignupValidator;
    this.$location = $location;
    this.currentUser = this.$auth.getUserData();
    this.currentUser.company.posting_types = [
      {id: 1, name: "On-Demand"},
      {id: 2, name: "Delivery"},
      {id: 3, name: "Pay For Post"},
    ];
    //this.check_posting_settings(this.currentUser.company.postingTypesAllowed);
    this.posting_settings_ui = {
      settings: {
        auto_hire: {
          is_checked: false,
        },
        auto_manage: {
          is_checked: false,
        },
        auto_post: {
          is_checked: false,
        },
      },
    };

    this.default_posting_settings = {
      value: {name: "On-Demand", id: 1},
      values: [
        {name: "On-Demand", id: 1},
        {name: "Delivery", id: 2},
        {name: "Pay For Post", id: 3},
      ],
    };

    var _this = this;

    _this.SetPostingTypesListener = _this.$rootScope.$on("SetPostingTypes", function ($event, params) {
      _this.determine_check_boxes(params);
      _this.getDoNotHireList();
    });

    _this.$scope.$on("$destroy", _this.SetPostingTypesListener);
  }

  post_type_saved(num) {
    var _this = this;

    _this.save_posting_success = true;
    _this.update_post_type(num);
    _this.$timeout(function () {
      _this.save_posting_success = false;
    }, 2000);
  }

  update_post_type(num) {
    var _this = this;

    let type_allowed = num;
    _this.$companies.update_post_type(type_allowed).then(
      function (response) {
        console.log("response");
        console.dir(response);
        _this.$localStorage.logged_user.company.postingTypesAllowed = response.data.postingTypesAllowed;
        _this.set_new_post_types_to_header(response.data.postingTypesAllowed);
      },
      function (error) {
        console.log("error");
        console.dir(error);
      }
    );
  }

  set_new_post_types_to_header(types) {
    var _this = this;
    _this.$timeout(function () {
      _this.$rootScope.$emit("SetNewPostTypesToHeader", types);
    });
  }

  on_demand_clicked() {
    var _this = this;

    if (_this.posting_settings_ui.settings.on_demand.is_checked) {
      _this.posting_settings_ui.settings.on_demand.is_checked = false;
    } else {
      _this.posting_settings_ui.settings.on_demand.is_checked = true;
    }

    let num = _this.determine_number();
    _this.post_type_saved(num);
  }

  pay_for_post_clicked() {
    var _this = this;

    if (_this.posting_settings_ui.settings.pay_for_post.is_checked) {
      _this.posting_settings_ui.settings.pay_for_post.is_checked = false;
    } else {
      _this.posting_settings_ui.settings.pay_for_post.is_checked = true;
    }

    let num = _this.determine_number();

    _this.post_type_saved(num);
  }

  delivery_clicked() {
    var _this = this;

    if (_this.posting_settings_ui.settings.delivery.is_checked) {
      _this.posting_settings_ui.settings.delivery.is_checked = false;
    } else {
      _this.posting_settings_ui.settings.delivery.is_checked = true;
    }

    let num = _this.determine_number();

    _this.post_type_saved(num);
  }

  determine_number() {
    var _this = this;

    let num = null;

    if (
      _this.posting_settings_ui.settings.on_demand.is_checked &&
      _this.posting_settings_ui.settings.pay_for_post.is_checked &&
      _this.posting_settings_ui.settings.delivery.is_checked
    ) {
      num = 0;
    } else if (
      _this.posting_settings_ui.settings.on_demand.is_checked &&
      _this.posting_settings_ui.settings.pay_for_post.is_checked &&
      !_this.posting_settings_ui.settings.delivery.is_checked
    ) {
      num = 1;
    } else if (
      _this.posting_settings_ui.settings.on_demand.is_checked &&
      !_this.posting_settings_ui.settings.pay_for_post.is_checked &&
      !_this.posting_settings_ui.settings.delivery.is_checked
    ) {
      num = 2;
    } else if (
      !_this.posting_settings_ui.settings.on_demand.is_checked &&
      _this.posting_settings_ui.settings.pay_for_post.is_checked &&
      !_this.posting_settings_ui.settings.delivery.is_checked
    ) {
      num = 3;
    } else if (
      !_this.posting_settings_ui.settings.on_demand.is_checked &&
      !_this.posting_settings_ui.settings.pay_for_post.is_checked &&
      _this.posting_settings_ui.settings.delivery.is_checked
    ) {
      num = 4;
    } else if (
      !_this.posting_settings_ui.settings.on_demand.is_checked &&
      _this.posting_settings_ui.settings.pay_for_post.is_checked &&
      _this.posting_settings_ui.settings.delivery.is_checked
    ) {
      num = 5;
    } else if (
      _this.posting_settings_ui.settings.on_demand.is_checked &&
      !_this.posting_settings_ui.settings.pay_for_post.is_checked &&
      _this.posting_settings_ui.settings.delivery.is_checked
    ) {
      num = 6;
    } else {
      num = 3;
    }

    return num;
  }

  check_back(t) {
    var _this = this;
    _this.$timeout(function () {
      _this.determine_check_boxes(t);
    }, 1000);
  }

  determine_check_boxes(user) {
    var _this = this;

    if (user) {
      if (user.company.autoAccept === true) {
        _this.posting_settings_ui.settings.auto_hire.is_checked = true;
      } else {
        _this.posting_settings_ui.settings.auto_hire.is_checked = false;
      }

      if (user.company.autoManage === true) {
        _this.posting_settings_ui.settings.auto_manage.is_checked = true;
      } else {
        _this.posting_settings_ui.settings.auto_manage.is_checked = false;
      }

      if (user.company.autoPost === true) {
        _this.posting_settings_ui.settings.auto_post.is_checked = true;
      } else {
        _this.posting_settings_ui.settings.auto_post.is_checked = true;
      }
    }
  }

  update_default_posting_type() {
    var _this = this;
    _this.post_type_saved();
  }

  check_posting_settings(post_settings) {
    var _this = this;
    _this.determine_check_boxes(post_settings);
  }

  setAutoManage() {
    var _this = this;

    _this.setLoader();

    let val = _this.posting_settings_ui.settings.auto_manage.is_checked;

    if (val === true) {
      _this.posting_settings_ui.settings.auto_manage.is_checked = false;
    } else {
      _this.posting_settings_ui.settings.auto_manage.is_checked = true;
    }

    let data = {
      autoManage: _this.posting_settings_ui.settings.auto_manage.is_checked,
    };

    _this.$companies.updateCompanyAutoManage(data).then(
      function (response) {
        _this.unSetLoader();
        _this.handleAutoManageResponse(response);
      },
      function (error) {
        _this.unSetLoader();
      }
    );
  }

  handleAutoManageResponse(response) {
    if (response.data.autoManage === true) {
      alert("Auto Manage feature has been turned on. Every job post from now on will automatically manage applicants.");
      this.setCurrentUser();
    } else {
      alert("Auto Manage feature has been turned off.");
      this.setCurrentUser();
    }
  }

  setAutoAcccept() {
    var _this = this;

    _this.setLoader();

    let val = _this.posting_settings_ui.settings.auto_hire.is_checked;

    if (val === true) {
      _this.posting_settings_ui.settings.auto_hire.is_checked = false;
    } else {
      _this.posting_settings_ui.settings.auto_hire.is_checked = true;
    }

    let data = {
      autoAccept: _this.posting_settings_ui.settings.auto_hire.is_checked,
    };

    /*
        _this.$companies.updateCompanyAutoAccept(data).then(
            function (response) {
                _this.unSetLoader();
                _this.handleAutoAcceptResponse(response);
            },
            function (error) {
                _this.unSetLoader();
            }
        );
         */
  }

  handleAutoAcceptResponse(response) {
    console.log("handleAutoAcceptResponse");
    console.dir(response);
    if (response.data.autoAccept === true) {
      alert("Auto Hire feature has been turned on. Every job post from now on with automatically hire applicants.");
      this.setCurrentUser();
    } else {
      alert("Auto Hire feature has been turned off.");
      this.setCurrentUser();
    }
  }

  setCurrentUser() {
    var _this = this;
    _this.$auth.validateUserByTokenWeb(_this.currentUser.access_token).then(
      function (response) {
        _this.currentUser = response.data;
        _this.currentUser.company.paymentInfos = response.data.company.undeletedPaymentInfos;
        _this.$localStorage.logged_user = _this.currentUser;
      },
      function (error) {}
    );
  }

  setLoader() {
    var _this = this;

    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;

    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  getDoNotHireList() {
    this.$companies.getDoNotHireList().then(
      (response) => {
        this.dnhJobblers = response.data;
        this.eachJobblerOnDNHList(response.data);
        this.getListOfAvailableDNH();
      },
      (error) => {}
    );
  }

  eachJobblerOnDNHList(jobblers) {
    jobblers.forEach(function (jobbler) {
      console.dir(jobbler.jobblerLastName);
    });
  }

  autoHirePreferenceChanging(data) {
    this.autoHireIsChanging = true;
    this.$timeout(() => {
      this.autoHireIsChanging = false;
    }, 1000);
  }

  blurAutoHirePreference(d) {
    this.setLoader();

    let data = {
      autoAcceptLimitTimeMark: d,
    };

    /*
        this.$companies.updateCompanyAutoAccept(data).then(
            (response) => {
                this.unSetLoader();
                this.setCurrentUser();
            },
            (error) => {
                this.unSetLoader();
            }
        );
         */
  }

  addUserToDNHList() {
    this.setLoader();

    let jobbler = this.findJobblerInList();

    if (!jobbler) {
      alert("This user has never worked for this company. Was not added to list");
      this.unSetLoader();
      return;
    }

    let data = {};
    let list = [];

    data.jobblerId = jobbler.id;
    data.description = "Test.";
    list.push(data);

    this.$companies.addToDNHList(list).then(
      (response) => {
        alert("User " + jobbler.username + " was added to the Do Not Hire List.");
        this.closeDNHModal();
        this.handleUI(response, jobbler);
        this.unSetLoader();
      },
      (error) => {
        alert("There was an error adding this user to the do not hire list.");
      }
    );
  }

  handleUI(response, jobbler) {
    let user = {};

    user.jobblerFirstName = jobbler.firstName;
    user.jobblerLastName = jobbler.lastName;
    user.jobblerUsername = jobbler.username;

    this.$timeout(() => {
      this.dnhJobblers.push(user);
      this.userForDNHList = "Email";
      this.disableDNH = true;
    });
  }

  findJobblerInList() {
    let user = this.availableDNHList.find((o) => o.username === this.userForDNHList);
    return user;
  }

  getListOfAvailableDNH() {
    this.$companies.getAvailableDNHList().then(
      (response) => {
        this.availableDNHList = response.data;
      },
      (error) => {
        console.log("in error...");
      }
    );
  }

  openDNHModal() {
    jQuery("#modal-add-user-to-do-no-hire-modal").modal();
  }

  closeDNHModal() {
    jQuery("#modal-add-user-to-do-no-hire-modal .modal-header button.close").trigger("click");
  }

  validateEmail() {
    let EMAILREGEX = /^([!#$%&*+-\/=?^`'|{}~\w_.]{1,64}?)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (this.userForDNHList) {
      if (this.userForDNHList.length > 0) {
        this.dnhEmailHasError = true;
      } else {
        this.dnhEmailHasError = false;
      }
    }

    if (EMAILREGEX.test(this.userForDNHList)) {
      this.dnhEmailHasError = false;
      this.disableDNH = false;
    }
  }

  removeDNH(user) {
    let data = {};

    data.jobblerId = user.jobblerId;

    this.setLoader();

    this.$companies.removeDoNotHireList(data).then(
      (response) => {
        this.unSetLoader();
        this.findUserRemoveFromList(user);
      },
      (error) => {
        this.unSetLoader();
      }
    );
  }

  findUserRemoveFromList(user) {
    let userIndex = this.dnhJobblers.findIndex((o) => o.jobblerId === user.jobblerId);

    this.dnhJobblers.splice(userIndex, 1);

    alert("User was successfully removed from the Do Not Hire List.");
  }
}

PosttypesController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$stateParams",
  "auth",
  "security",
  "signup.validator",
  "companies",
  "$timeout",
  "$rootScope",
  "env",
  "ngProgressFactory",
  "$scope",
  "$location",
];

export default PosttypesController;



// WEBPACK FOOTER //
// ./client/app/components/accountprofile/posttypes/posttypes.controller.js